import { API } from "../../api/api.js";
import { APP_ANALYTICS_URL } from "../../config";

export const getAppAnalytics = (endPoints,packageName,platform,appName='') => {
   if(!packageName){
      packageName=undefined;}
   return API(`${APP_ANALYTICS_URL}analytics/apps/${endPoints}/${packageName}/${appName}?platform=${platform}`, 'get')
}

export const getNumberOfInstalls = (endPoints,appId,platformType) => {
   return API(`${APP_ANALYTICS_URL}analytics/apps/${endPoints}`, 'post',{
      "platform": platformType,
    "appId": appId
   })
}

export const getAppRatings = (appId,platform) => {
   return API(`${APP_ANALYTICS_URL}analytics/apps/avgAppRating/${appId}?platform=${platform}`, 'get')
}